(function () {
    // Accordion functionality for author list
    var $accordionContent = wo$('#smallAccordionContent');
    var $accordionTrigger = wo$('#smallAccordionTrigger');

    function getAuthors() {
        // Only the extra authors live in the accordion content area.
        return $accordionContent.find('address');
    }

    function updateTrigger(isOpen, count) {
        $accordionTrigger.attr('aria-expanded', isOpen ? 'true' : 'false');

        if (isOpen) {
            $accordionTrigger.html('<span class="c-blue">-</span> View Less');
            return;
        }

        $accordionTrigger.html('<span class="c-blue">+</span> ' + count + ' more');
    }

    function removeSeparators() {
        // Clear previously injected punctuation before rebuilding.
        wo$('.author-separator').remove();
    }

    function addSeparators($authors) {
        // Build natural-language punctuation: comma-separated list with final 'and'.
        var count = $authors.length;

        if (count === 1) {
            wo$('#firstAuthor').after('<span class="author-separator"> and </span>');
        } else if (count > 1) {
            wo$('#firstAuthor').after('<span class="author-separator">, </span>');
        }

        $authors.each(function (index, element) {
            if (index < count - 1) {
                var separator = index === count - 2 ? ' and ' : ', ';
                wo$(element).after('<span class="author-separator">' + separator + '</span>');
            }
        });
    }

    var initialCount = getAuthors().length;
    // Start collapsed and keep accessibility state in sync.
    updateTrigger(false, initialCount);
    $accordionContent.hide().attr('aria-hidden', 'true');

    $accordionTrigger.click(function () {
        var isOpen = $accordionContent.is(':visible');
        var $authors = getAuthors();
        var count = $authors.length;

        if (isOpen) {
            // Collapse list back to summary state.
            $accordionContent.hide().attr('aria-hidden', 'true');
            updateTrigger(false, count);
            removeSeparators();
            return;
        }

        // Expand and render separators for a readable byline list.
        $accordionContent.show().attr('aria-hidden', 'false');
        updateTrigger(true, count);
        removeSeparators();
        addSeparators($authors);
    });
})();
